import { render, staticRenderFns } from "./CareerGraphProject.vue?vue&type=template&id=2b705b3a&scoped=true&"
import script from "./CareerGraphProject.vue?vue&type=script&lang=js&"
export * from "./CareerGraphProject.vue?vue&type=script&lang=js&"
import style0 from "./CareerGraphProject.vue?vue&type=style&index=0&id=2b705b3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b705b3a",
  null
  
)

export default component.exports